import styled from "@emotion/styled"
import { MakeRequired } from "typescript/utils"
import { TSVGIcon } from "./SVGIcon"

type TSVGStyledIcon = MakeRequired<Omit<TSVGIcon, "path">, "width" | "height">

export const SVG = styled.svg<TSVGStyledIcon>`
  height: ${({ height }) => `${height / 10}rem`};
  width: ${({ width }) => `${width / 10}rem`};
  fill: currentColor;
  transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1);
  flex-grow: 0;
  flex-shrink: 0;

  ${({ hoverColor }) => hoverColor && `color: ${hoverColor};`}
`
